import React, { useEffect } from 'react';
import LandingNavbar from '../LandingNavbar';
import LandingFooter from '../LandingFooter';
import './ResourcesLayout.css';

/**
 * ResourcesLayout — Shared wrapper for all resource pages
 * Provides consistent LandingNavbar + LandingFooter + scroll-to-top
 */
const ResourcesLayout = ({ children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="rsc-layout">
      <LandingNavbar />
      <main className="rsc-main">
        {children}
      </main>
      <LandingFooter />
    </div>
  );
};

export default ResourcesLayout;
